import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { MoneyService } from 'src/app/Service/Money/Money.service';

@Component({
  selector: 'app-MoneyEdit',
  templateUrl: './MoneyEdit.component.html',
  styleUrls: ['./MoneyEdit.component.scss']
})
export class MoneyEditComponent implements OnInit {

  Token:String=""
  EditRecord:Number

  constructor(
    private Money_Service:MoneyService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.EditMoney=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))


    this.Nav_Service.CheckValidPage(this.Token,1125).subscribe(
      data=>{
        this.Money_Service.GetSingle(this.Token,this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)

          }
        )
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }

    //#region  Form Add

    EditMoney:FormGroup;

    get_Form_Id(){
      return this.EditMoney.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditMoney.get('Title') as FormControl;
    }

    //#endregion

    InProccessing:boolean=false

    SubmitEditMoney(){
      var Record:General_Interface =Empty_General_Interface()
      Record.id=this.get_Form_Id().value
      Record.title=this.get_Form_Title().value
      this.InProccessing=true
      this.Money_Service.EditMoney(Record,this.Token).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
          }
          else{

            this.Alertify_Service.SuccessMessage("Information saved successfully.")
          }
        }
      )
    }
}
